import React from 'react';
import { connect } from 'react-redux';
import AppControls from './AppControls';
import UnsanctionedApps from './UnsanctionedApps';

// Web Controls — App & Site Access Policy (+ per-app DLP overrides), plus the
// Unsanctioned Apps discovery list (PIXMC-6083 §10.1) rendered below it. Web-only —
// AIControls does not get the discovery list (D13: unsanctioned-app telemetry is a
// Web Controls concept only).
//
// The one bit of store access here (unsanctionedDiscoveredCount) feeds AppControls'
// stat card (§10.2) without making AppControls itself read the store — it stays the
// pure, caller-supplied component AIControls also relies on. UnsanctionedApps below
// triggers the actual fetch on mount; this just reads whatever it last put in state.
// Wrapped in a plain div, not a Fragment: the parent LoaderWrapper (isFlex) is a
// row flexbox, so a Fragment's children render as two direct flex-row siblings
// (side by side) instead of stacking. A single block-level wrapper makes this one
// flex item, which stacks AppControls/UnsanctionedApps normally inside it.
const WebControls = (props) => (
  <div style={{ width: '100%' }}>
    <AppControls {...props} controlType="WEB" unsanctionedDiscoveredCount={props.unsanctionedDiscoveredCount} />
    <UnsanctionedApps customerId={props.customerId} />
  </div>
);

const mapStateToProps = (state) => ({
  unsanctionedDiscoveredCount: state.entities.governance.unsancAppsTotalCount,
});

export default connect(mapStateToProps)(WebControls);
